import React from 'react';
import styled from 'styled-components'
import { InputField } from '../../components/InputField'

interface Props {
	phoneDirectoryUserInfo: any;
	onChange: (field: string, value: string) => void;
	disabled: boolean;
	phoneDirectoryFieldNames?: any[];
	showErrors: boolean;
}

const ErrorMessage = styled.div`
	color: red;
`;

export const PhoneDirectoryUserInfo: React.FC<Props> = (props: Props) => {
	const userDetails = props.phoneDirectoryUserInfo;
	const fieldNames = props.phoneDirectoryFieldNames;
	return (
		<div>
			<InputField
				title={'Etunimi (pakollinen tieto)'}
				field={fieldNames ? fieldNames[0] : 'phone-directory-first-name'}
				value={userDetails ? userDetails.firstName : ''}
				onChange={props.onChange}
				disabled={props.disabled}
			/>
			<InputField
				title={'Sukunimi (pakollinen tieto)'}
				field={fieldNames ? fieldNames[1] : 'phone-directory-last-name'}
				value={userDetails ? userDetails.lastName : ''}
				onChange={props.onChange}
				disabled={props.disabled}
			/>
			<InputField
				title={'Osoite'}
				field={fieldNames ? fieldNames[2] : 'phone-directory-street-address'}
				value={userDetails ? userDetails.streetAddress : ''}
				onChange={props.onChange}
				disabled={props.disabled}
			/>
			<InputField
				title={'Postinumero'}
				field={fieldNames ? fieldNames[3] : 'phone-directory-zip-code'}
				value={userDetails ? userDetails.zipCode : ''}
				onChange={props.onChange}
				disabled={props.disabled}
			/>
			{props.showErrors && (
				<ErrorMessage>Tarkista kenttä</ErrorMessage>
			)}
			<InputField
				title={'Postitoimipaikka'}
				field={fieldNames ? fieldNames[4] : 'phone-directory-city'}
				value={userDetails ? userDetails.city : ''}
				onChange={props.onChange}
				disabled={props.disabled}
			/>
		</div>
	)
};